import React from 'react';

import {Card, Heading, ListGroupItem} from '@albert-io/atomic';

import './empty-question-shell.scss';

export default function EmptyQuestionShell() {
  return (
    <Card className='empty-question-shell'>
      <ListGroupItem>
        <Heading as='h1' size='xs' className='u-mar_0'>
          <span>&nbsp;</span>
        </Heading>
      </ListGroupItem>
      <div className='u-pad_4 empty-question-shell__body' />
    </Card>
  );
}
